import { ButtonVariant, CoButton } from "components/CoButton";
import Tooltip from "components/Tooltip";
import useLabels from "hooks/useLabels";
import { useSidebar } from "hooks/useSidebar";
import { PanelLeft } from "lucide-react";

function OpenSidebarButton() {
  const { toggleSidebar } = useSidebar();

  const handleOnClick = () => {
    toggleSidebar();
  };

  const [sidebarLabels] = useLabels("screens.sidebar");

  return (
    <Tooltip content={sidebarLabels["open-sidebar"]} placement="bottom">
      <CoButton
        data-testid="open-sidebar-button"
        aria-label={sidebarLabels["open-sidebar"]}
        variant={ButtonVariant.Flat}
        icon={<PanelLeft className="text-fg-base" size={20} />}
        onClick={handleOnClick}
        size="sm"
        className="cursor-e-resize"
      />
    </Tooltip>
  );
}

export default OpenSidebarButton;
